<template>
  <pui-flex class="pui-file-notification" direction="column" flex="1">
    <!-- UPLOADING FILES OR WAITING -->
    <template
      v-if="
        data.state === ExternalLinkImportStates.UPLOADING_FILES ||
          data.state === ExternalLinkImportStates.PROCESSING
      "
    >
      <pui-flex class="file-notification-title">
        <span class="notif-title-main__picto mdi mdi-clock-outline"></span>
        <div class="notif-title-main">
          {{
            $t('dam.files.import_external_link.import_notification.title.media_count', {
              successCount: data.successFileCount,
              totalCount: data.totalFileCount,
            })
          }}
        </div>
        <div class="notif-title-secondary">
          <template v-if="data.state === ExternalLinkImportStates.UPLOADING_FILES">
            {{ $t('dam.files.import_external_link.import_notification.title.uploading') }}
          </template>
          <template v-else-if="data.state === ExternalLinkImportStates.PROCESSING">
            {{ $t('dam.files.import_external_link.import_notification.title.files_sent') }}
          </template>
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <template v-if="data.state === ExternalLinkImportStates.PROCESSING">
          {{ $t('dam.files.import_external_link.import_notification.message.processing') }}
        </template>
        <pui-common-progress-linear
          :determinate="data.state === ExternalLinkImportStates.UPLOADING_FILES"
          :value="progressPercentage"
          hideMessage
        />
        <template v-if="data.state === ExternalLinkImportStates.UPLOADING_FILES">
          {{ $t('dam.files.import_external_link.import_notification.message.warn_no_close') }}
        </template>
      </div>
    </template>

    <!-- UPLOAD ERROR -->
    <template v-else-if="data.state === ExternalLinkImportStates.DONE_ERROR">
      <pui-flex class="file-notification-title notification-error">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-alert-circle-outline"></span>
          {{ $t('dam.files.import_external_link.import_notification.title.error') }}
        </div>
        <div class="notif-title-secondary">
          <pui-button
            @click.stop="dismissNotification"
            picto="mdi-close"
            flat
            variant="secondary"
          />
        </div>
      </pui-flex>
      <div class="file-notification-content">
        <div>
          {{ $t('dam.files.import_external_link.import_notification.message.error.primary') }}
        </div>
        <div>
          {{ $t('dam.files.import_external_link.import_notification.message.error.secondary') }}
        </div>
      </div>
    </template>

    <!-- UPLOAD & PROCESSING SUCCESS -->
    <template v-else-if="data.state === ExternalLinkImportStates.DONE_SUCCESS">
      <pui-flex class="file-notification-title notification-success">
        <div class="notif-title-main">
          <span class="notif-title-main__picto mdi mdi-check-circle-outline"></span>
          {{ $t('dam.files.import_external_link.import_notification.title.success') }}
        </div>
        <div class="notif-title-secondary">
          <pui-button
            @click.stop="dismissNotification"
            picto="mdi-close"
            flat
            variant="secondary"
          />
        </div>
      </pui-flex>
      <div class="file-notification-content">
        {{
          $t('dam.files.import_external_link.import_notification.message.media_count.message', {
            successCount: data.successFileCount,
            totalCount: data.totalFileCount,
          })
        }}
        <span v-if="hasErroredFileUploads">
          {{
            $t(
              'dam.files.import_external_link.import_notification.message.media_count.error.of_which'
            )
          }}
          <pui-button @click="openErroredFilesDialog" flat variant="tertiary">{{
            $t(
              'dam.files.import_external_link.import_notification.message.media_count.error.corrupted_count',
              {
                count: data.errorFileNames.length,
              }
            )
          }}</pui-button>
        </span>
      </div>
    </template>
  </pui-flex>
</template>

<script>
import Vue from 'vue';

import puiFileUploadError from '../../../common/components/upload/FileUploadError.vue';
import services from '../../../../core/services';
import notificationItemMixin from '../../../../platform/components/notifications/notificationItemMixin';
import { ExternalLinkImportStates } from '../../constants/attribute';

export default {
  name: 'pui-external-link-import-notification',
  mixins: [notificationItemMixin],
  data() {
    return {
      ExternalLinkImportStates,
    };
  },
  computed: {
    /**
     * @returns {Number} the percentage of uploaded files
     */
    progressPercentage() {
      if (
        !this.data ||
        this.data.state !== ExternalLinkImportStates.UPLOADING_FILES ||
        this.data.totalFileCount <= 0
      ) {
        return 0;
      }

      const percentage = (this.data.successFileCount / this.data.totalFileCount) * 100;
      return Math.round(percentage);
    },
    /**
     * @returns {boolean} if there are any files that were not uploaded
     */
    hasErroredFileUploads() {
      return this.data.errorFileNames && this.data.errorFileNames.length > 0;
    },
  },
  methods: {
    // FILTERS
    piivoTranslate(value) {
      return Vue.filter('piivoTranslate')(value);
    },
    // NOTIF ACTIONS
    /**
     * Removes this notification
     *
     * @returns {void}
     */
    dismissNotification() {
      services.getService('notifications').removeNotification(this.id);
    },
    // FILES
    /**
     * Opens the errored files dialog
     *
     * @returns {void}
     */
    openErroredFilesDialog() {
      this.$emit('openDialog', puiFileUploadError, {
        errorFileNames: this.data.errorFileNames,
      });
    },
  },
};
</script>
